import { render, staticRenderFns } from "./PopupAdd.vue?vue&type=template&id=809a8668&scoped=true"
import script from "./PopupAdd.vue?vue&type=script&lang=js"
export * from "./PopupAdd.vue?vue&type=script&lang=js"
import style0 from "./PopupAdd.vue?vue&type=style&index=0&id=809a8668&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "809a8668",
  null
  
)

export default component.exports